let $ = jQuery.noConflict(),
	devMode,
	scrollController,
	foregroundContent,
	body,
	firstLoad = true,
	mobileCheck = false,
	currentY = 0,
	scrollBar,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	mobileResizeCallbacks = [];

$(function () {
	initEndor();

	// Composants spécifiques endor
	new BannerSlider();
	new BannerVideo();
	new Buttons();
	new BlockGallery();
	new BlockSliderImages();
	new BlockSliderRichText();
	new EditorText();
	new IframeVideos();
	new GoogleMap();
	new Nav();

	new PagePrivate();

	// Composants spécifique site Mobile & Desktop
	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});

function initEndor() {
	body = $('body');
	mcubeDebug();
	foregroundContent = $('.foreground-content');
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	new SmoothScroll();
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new AppearOnScroll();
	new DataLink();
	new Forms();
	new InitMatchHeight();
	new MadeByMcube();
}

function scrollListener(newY) {

}
